import debug from 'debug';
import { STORAGE_KEY } from '@/constant/constant';
import { setLocal } from '@/utils/storage';
import { isValidEmail } from '@/utils/index';

const log = debug('cartsee:shopline:newsletter');

export const shoplineNewsletter = () => {
  log('shoplineNewsletter');

  // 监听所有表单提交
  document.addEventListener('submit', function (event) {
    log('Newsletter submit event');
    try {
      const form = event.target as HTMLFormElement;
      if (form.action.includes('/api/user/front/form/subscribe')) {
        const emailInput = form.querySelector('input[type="email"]') as HTMLInputElement;
        if (emailInput && emailInput.value) {
          const email = emailInput.value;
          log('Newsletter subscription Form:', email);
          // 订阅成功时缓存邮箱，供后续埋点或拉新用
          setLocal(STORAGE_KEY.NEWSLETTER_EMAIL, email);
        }
      }
    } catch (error) {
      console.error('Newsletter form submission error:', error);
    }
  });

  // 使用事件代理监听按钮点击事件
  // 只有在用户点击提交按钮时才保存邮箱到localStorage
  document.addEventListener(
    'click',
    function (event: Event) {
      const target = event.target as HTMLElement;

      // 检查是否点击了newsletter按钮
      const button = target.closest('.footer__newsletter-btn');

      if (button) {
        log('Newsletter button clicked');

        // 在同一个 footer__newsletter-input 容器内查找input
        const container = button.closest('.footer__newsletter-input');
        const emailInput = container?.querySelector('input') as HTMLInputElement;

        if (emailInput && emailInput.value) {
          const email = emailInput.value.trim();

          // 校验邮箱格式
          if (isValidEmail(email)) {
            log('Newsletter subscription Footer (valid email):', email);
            setLocal(STORAGE_KEY.NEWSLETTER_EMAIL, email);
          } else {
            log('Newsletter subscription Footer (invalid email):', email);
          }
        }
      }
    },
    true
  );
};
